import Reveal from '@/components/base/Reveal';
import { distributorBenefits, partnerReasons, productsUrl, whatsappUrl } from '@/mocks/homeData';

export default function DistributorSection() {
  return (
    <section id="distributor" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <Reveal>
          <div className="relative overflow-hidden rounded-2xl bg-primary-950 px-6 py-10 md:px-12 md:py-14">
            <div className="pointer-events-none absolute -top-24 -right-16 w-72 h-72 rounded-full bg-primary-800/60 blur-3xl"></div>
            <div className="pointer-events-none absolute -bottom-24 -left-16 w-72 h-72 rounded-full bg-accent-500/10 blur-3xl"></div>

            <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
              <div className="w-full">
                <span className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.22em] text-accent-300">
                  <span className="w-6 h-px bg-accent-300"></span>
                  Grow With Us
                </span>
                <h2 className="font-heading mt-3 text-2xl md:text-4xl font-semibold leading-tight text-background-50">
                  Become a Distributor
                </h2>
                <span className="block h-[3px] w-16 rounded-full bg-accent-500 mt-4"></span>
                <p className="mt-4 text-sm md:text-base leading-relaxed text-background-100/80 max-w-xl">
                  Partner with Best Research Pharma and grow your business with a trusted range of 150+ Ayurvedic
                  products. We support distributors, stockists and healthcare businesses across India with dependable
                  quality, region-wise rights and reliable supply.
                </p>

                <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {distributorBenefits.map((item) => (
                    <div key={item.id} className="flex gap-3">
                      <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-full bg-primary-800 text-accent-300">
                        <i className={`${item.icon} text-base`}></i>
                      </span>
                      <div>
                        <h3 className="font-heading text-sm font-semibold text-background-50">{item.title}</h3>
                        <p className="mt-0.5 text-xs md:text-sm text-background-100/70">{item.description}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="mt-8 flex flex-col sm:flex-row flex-wrap gap-3">
                  <a
                    href="#distributor-apply"
                    className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-primary-950 text-sm font-semibold hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-file-add-line text-base"></i>
                    Apply Now
                  </a>
                  <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-100/30 text-background-50 text-sm font-semibold hover:bg-primary-800 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-whatsapp-line text-base"></i>
                    Chat on WhatsApp
                  </a>
                  <a
                    href={productsUrl}
                    className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-100/30 text-background-50 text-sm font-semibold hover:bg-primary-800 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    View Our Range
                    <i className="ri-arrow-right-line text-base"></i>
                  </a>
                </div>
              </div>

              <Reveal delay={120}>
                <div className="w-full">
                  <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden border border-primary-800">
                    <img
                      src="https://readdy.ai/api/search-image?query=Ayurvedic%20herbal%20medicine%20distribution%20warehouse%20with%20neatly%20stacked%20green%20product%20boxes%20on%20shelves%2C%20delivery%20cartons%20and%20a%20logistics%20cart%2C%20bright%20clean%20interior%20with%20warm%20natural%20lighting%2C%20professional%20editorial%20photography%2C%20cohesive%20green%20and%20beige%20color%20palette%2C%20high%20detail%2C%20soft%20shadows%2C%20wide%20composition&width=800&height=600&seq=distributor-warehouse-2026a&orientation=landscape"
                      alt="Best Research Pharma Ayurvedic product distribution warehouse"
                      title="Become a Distributor - Best Research Pharma"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </Reveal>
            </div>
          </div>
        </Reveal>

        <Reveal delay={80}>
          <div className="mt-8 md:mt-12">
            <div className="flex items-center gap-2">
              <span className="w-6 h-px bg-primary-500"></span>
              <span className="text-xs font-semibold uppercase tracking-[0.22em] text-primary-700">
                Why Partner With Us
              </span>
            </div>
            <div className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
              {partnerReasons.map((item) => (
                <div
                  key={item.id}
                  className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
                >
                  <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h3 className="font-heading text-sm font-semibold text-foreground-950">{item.title}</h3>
                    <p className="mt-1 text-xs md:text-sm text-foreground-600">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}